import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-scroll-search-medoc',
  templateUrl: './scroll-search-medoc.component.html',
  styleUrls: ['./scroll-search-medoc.component.scss']
})
export class ScrollSearchMedocComponent implements OnInit {

items: Array<any> = [];
  user: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  busyGet: Subscription;
  searchKeyPrestataire: any = "";
  prestataire_id:any
  @Input() type_prestataire_id: any;
  @Input() reseau_de_soin_id: any;
  @Input() current_prestataire_id: any;
  @Input() clearText: any;
  @Output() onSelectPrestataire = new EventEmitter();
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    
  }

  ngOnChanges(changes: SimpleChanges) {
    
    if (changes.type_prestataire_id && changes.type_prestataire_id.currentValue) {
      this.type_prestataire_id = changes.type_prestataire_id.currentValue;
    }
    if (changes.reseau_de_soin_id && changes.reseau_de_soin_id.currentValue) {
      this.reseau_de_soin_id = changes.reseau_de_soin_id.currentValue;
    }
    if (changes.current_prestataire_id && changes.current_prestataire_id.currentValue) {
      this.prestataire_id = changes.current_prestataire_id.currentValue;
    }
    if (changes.clearText && changes.clearText.currentValue) {
      this.clearSelection()
    }
    this.itemsPerPage=10
    this.getItems()
  }
  onSearch(event) {
    console.log("fkdkfjkd", event);
    this.itemsPerPage = 10;
    this.searchKeyPrestataire = event.term;
    if(event.term.length)
      this.getItems();
  }

  clearSelection() {
    this.prestataire_id = null; // or undefined
    this.items=[]
    this.searchKeyPrestataire = ''
  }
  

  onGetMoreItems() {
    this.itemsPerPage += 5;
    this.getItems();
  }


  onSelectElement(){

    this.onSelectPrestataire.emit(this.prestataire_id)

  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: this.itemsPerPage,
      search_key: this.searchKeyPrestataire,
      data: {
        reseau_de_soin_id: this.reseau_de_soin_id,
        type_prestataire_id: this.type_prestataire_id,
      },
    };

    this.busyGet = this.restClient
      .post("prestataire/getByReseauDeSoin", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.items = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.items = [];
          }
        },
        (err) => {
          this.items = [];
        }
      );
  }
  


  onSelectTypePrestataire() {}

  ngOnInit() {
  }

}
